const settingLang = {
  LOGIN: ['LOGIN', '登录'],
  LOGIN_FACEBOOk: ['LOGIN FACEBOOk', '登录FACCEBOOK'],
  Connect_a_Facebook_Pages: [
    'Connect a Facebook Pages',
    '链接一个Facebook主页'
  ],
  Connect: ['Connect', '连接'],
  Connecting: ['Connecting', '连接中'],
  Disconnect: ['Disconnect', '断开连接'],
  TEXT: ['TEXT', '文本'],
  First_Image: ['FIRST IMAGE', '第一张图片'],
  BUTTON_TEXT: ['BUTTON  TEXT', '按钮文案'],
  SECOND_IMAGE: ['SECOND  IMAGE', '第二张图片'],
  Default_welocome_Messenger: ['Default welocome Messenger', '恢复默认值'],
  Save: ['Save', '保存'],
  Send_to_Messenger: ['Send to Messenger', '发送到messenger'],
  preview: ['Preview', '预览'],
  Reloading: ['Reloading', '重新加载'],
  Reset: ['Reset', '恢复默认'],
  Connect_Pages: ['Connect a Facebook Pages', '请连接一个Facebook主页'],
  Setting_Your_Messenger: [
    'Setting your Messenger,Plese click the button at the top right',
    '设置你的messenger，请先点击右上方按钮'
  ],
  Use_GIFs_to: [
    'Use GIFs to boost customer engagement MAX.5M（1.9：1）',
    'GIF动图可以提高客户回复消息机会图片小于5M,比例1.9：1'
  ]
};

export default settingLang;
